"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductListingContext = exports.productListingContext = exports.ProductListingProvider = void 0;
var _analyticsData = require("@ori/analytics-data");
var _react = require("react");
var _useGetProductBoxPlacement = require("../utils/useGetProductBoxPlacement");
var _jsxRuntime = require("react/jsx-runtime");
const defaultProductListingContextValues = {
    productBoxConfiguration: {},
    placement: _analyticsData.Placement.ProductListing
};
const productListingContext = exports.productListingContext = /*#__PURE__*/ (0, _react.createContext)(defaultProductListingContextValues);
const { Provider } = productListingContext;
const ProductListingProvider = (param)=>{
    let { productBoxConfiguration, children } = param;
    const placement = (0, _useGetProductBoxPlacement.useGetProductBoxPlacement)();
    const value = (0, _react.useMemo)(()=>({
            productBoxConfiguration,
            placement
        }), [
        placement,
        productBoxConfiguration
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
    });
};
exports.ProductListingProvider = ProductListingProvider;
const useProductListingContext = ()=>(0, _react.useContext)(productListingContext);
exports.useProductListingContext = useProductListingContext;
